import '../../assets/components/Accordion/accordion.css';const o = "_accordionMarker_n5xcg_1", c = "_open_n5xcg_4", n = "_closed_n5xcg_7", e = "_accordionHeading_n5xcg_12", a = "_accordionContent_n5xcg_44", d = {
  accordionMarker: o,
  open: c,
  closed: n,
  accordionHeading: e,
  accordionContent: a
};
export {
  a as accordionContent,
  e as accordionHeading,
  o as accordionMarker,
  n as closed,
  d as default,
  c as open
};
